import {List} from 'immutable'
import PropTypes from 'prop-types'

import Avatar from '@mui/material/Avatar'
import AvatarGroup from '@mui/material/AvatarGroup'

import {userInitials} from '../../../../../../lib/nameTools'

import './deputiesAvatar.scss'

const DeputiesAvatar = ({deputies = List()}) => {
  const maxVisible = 3
  const visibleAvatars = deputies ? deputies.slice(0, maxVisible) : []
  const additionalDeputiesCount = deputies &&
  deputies.size > maxVisible ?
    deputies.size - maxVisible :
    0

  return (
    <div className='deputies-avatar'>
      <div className='deputies-avatar__text'>Shared with</div>
      <div className='avatars-container'>
        <AvatarGroup>
          {
            visibleAvatars.map(deputy => (
              <Avatar
                className='avatar'
                key={deputy.get('id')}>
                {userInitials(deputy.get('ownable')) || '?'}
              </Avatar>
            ))
          }
        </AvatarGroup>
        {
          additionalDeputiesCount > 0 &&
          <div className='deputies-avatar__text'>
            {`+${additionalDeputiesCount} more`}
          </div>
        }
        <span className='add-another-link'>Add another</span>
      </div>
    </div>
  )
}

DeputiesAvatar.propTypes = {deputies: PropTypes.instanceOf(List)}

export default DeputiesAvatar
